import { AfterViewInit, Component } from "@angular/core";
import { RouterModule, RouterOutlet } from "@angular/router";
import { LANG } from "@app/shared/interfaces/lang.enum";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { LoadingComponent } from "./shared/components/loading/loading.component";
import { HeaderComponent } from "@app/shared/components/header/header.component";
import { DeviceDetectionService } from "./shared/services/device-detection/device-detection.service";
import { UtilsService } from "./shared/services/util/utils.service";

export interface ModalProperties {
  icon: string;
  title: string;
  subtitle: string;
  button: string;
  buttonLabel: string;
}

@Component({
  selector: "vass-root",
  templateUrl: "./app.component.html",
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    LoadingComponent,
    RouterModule,
    RouterOutlet,
    TranslateModule,
  ]
})
export class AppComponent implements AfterViewInit {
  browserLang: string | undefined;
  constructor(
    public translate: TranslateService,
    private readonly _deviceDetectionSrv: DeviceDetectionService,
    private readonly _utilService: UtilsService
  ) {
    translate.addLangs([LANG.ES, LANG.EN]);
    translate.setDefaultLang(LANG.ES);
    this.browserLang = translate.getBrowserLang();
    if (this.browserLang) {
      translate.use(
        this.browserLang.match(/es|en/) ? this.browserLang : LANG.ES
      );
    }
  }
  
  ngAfterViewInit(): void {
    const device = this._deviceDetectionSrv.getFullDeviceInfo();
    this._utilService.setDeviceType(device);
  }

}
